import React from "react";
import { useStoreAppValue } from "@hooks";
// import styled from "@emotion/styled";
// import { BeneficiaryLoading } from "../BeneficiaryLoading";
import { useQuery } from "react-apollo";
import { BeneficiaryForm } from "../BeneficiaryForm";
import {
  CampaignBeneficiaryQueryVariables,
  CampaignBeneficiaryQuery,
} from "../BeneficiaryForm/__generated__/CampaignBeneficiaryQuery";
import { useCookies } from "react-cookie";
import { BeneficiaryLoading } from "../BeneficiaryLoading";
import { navigate } from "@reach/router";
import { RailsUrl } from "@services";
import gql from "graphql-tag";

// == Types ================================================================

interface IProps {}

// == Constants ============================================================

BeneficiaryFormQuery.defaultProps = {};
export const CAMPAIGN_BENEFICIARY_QUERY = gql`
  query CampaignBeneficiaryQuery($id: ID) {
    Campaign(id: $id) {
      id
      category {
        id
      }
      beneficiary {
        id
        city
        contactName
        dateOfBirth
        email
        firstName
        hwUserToken
        hwUserVerificationStatus
        hwAccountInfo
        hwAccountToken
        id
        lastName
        legalName
        paymentType
        phoneNumber
        postalCode
        province
        street1
        street2
        taxId
        realTeamName
        teamName
        teamType
        website
        plaidAccountId
        plaidAccountInfo
        plaidPublicToken
        googlePlacesId
      }
      organization {
        id
        name
        city
        country
        legalName
        postalCode
        province
        street1
      }
    }
  }
`;

// == Component ============================================================

export default function BeneficiaryFormQuery(props: IProps) {
  const { campaignId } = useStoreAppValue();
  const [cookies, _setBeneficiaryType] = useCookies(["beneficiaryType"]);

  const { data, error, refetch, loading } = useQuery<
    CampaignBeneficiaryQuery,
    CampaignBeneficiaryQueryVariables
  >(CAMPAIGN_BENEFICIARY_QUERY, {
    variables: {
      id: campaignId,
    },
    fetchPolicy: "no-cache",
    onCompleted: (data) => {
      if (!cookies.beneficiaryType && !data?.Campaign?.beneficiary) {
        navigate(RailsUrl.beneficiaryIntroUrl(campaignId), { replace: true });
      }
    },
  });

  if (!data || loading) return <BeneficiaryLoading />;

  const beneficiary = data?.Campaign?.beneficiary;

  return <BeneficiaryForm beneficiary={beneficiary} />;
}

// == Styles ===============================================================
